import { useState, useLayoutEffect } from "react";

export const useIntersection = (element, rootMargin) => {
  const [isVisible, setState] = useState(false);
  useLayoutEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setState(entry.isIntersecting);
      },
      {
        threshold: [0.1, 1],
      }
    );
    element.current && observer.observe(element.current);

    return () => {
      observer.unobserve(element.current);
    };
  }, [element, rootMargin]);

  return isVisible;
};

export function formatMoney(value, checkFractionDigits = false) {
  if (!value) return "$0.00";
  let numValue = 0;
  if (value?.toString().includes(",")) {
    numValue = parseFloat(value.replace(",", ""));
  } else {
    numValue = parseFloat(value);
  }
  if (Number.isNaN(numValue)) {
    return value;
  }
  return numValue.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: checkFractionDigits && numValue % 1 === 0 ? 0 : 2,
  });
}
